module.exports = __webpack_public_path__ + "static/ume01-afa57e5eb692e44e80f5bbb69af491a9.png";